import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');

    if (storedToken && storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setToken(storedToken);
      setUser(parsedUser);
      api.defaults.headers.common['Authorization'] = `Bearer ${storedToken}`;

      if (!parsedUser.empresa_timezone && parsedUser.empresa_id) {
        api.get(`/empresas?id=${parsedUser.empresa_id}`)
          .then((response) => {
            const empresa = (response.data.data || response.data)?.[0];
            if (!empresa) return;

            const enrichedUser = {
              ...parsedUser,
              empresa_timezone: empresa.timezone || parsedUser.empresa_timezone,
              empresa_whatsapp_api_key: empresa.whatsapp_api_key || parsedUser.empresa_whatsapp_api_key,
              empresa_whatsapp_instance: empresa.whatsapp_instance || parsedUser.empresa_whatsapp_instance,
            };
            localStorage.setItem('user', JSON.stringify(enrichedUser));
            setUser(enrichedUser);
          })
          .catch((error) => {
            console.error('Erro ao carregar dados da empresa:', error);
          });
      }
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    const updateUserFromSession = () => {
      const storedUser = localStorage.getItem('user');
      if (!storedUser) return;
      const parsed = JSON.parse(storedUser);
      setUser((prev) => (prev && JSON.stringify(prev) === JSON.stringify(parsed) ? prev : parsed));
    };
    window.addEventListener('auth:user-updated', updateUserFromSession);
    return () => window.removeEventListener('auth:user-updated', updateUserFromSession);
  }, []);

  const login = (newToken, newUser) => {
    localStorage.setItem('token', newToken);
    localStorage.setItem('user', JSON.stringify(newUser));
    setToken(newToken);
    setUser(newUser);
    api.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
    delete api.defaults.headers.common['Authorization'];
  };

  const switchCondominio = async (empresaId) => {
    const response = await api.post('/auth/switch-condominio', { empresa_id: empresaId });
    const newToken = response.data.token;
    const newUser = response.data.user;
    localStorage.setItem('token', newToken);
    localStorage.setItem('user', JSON.stringify(newUser));
    setToken(newToken);
    setUser(newUser);
    api.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
    return newUser;
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, logout, switchCondominio }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
